export const normalizeLineEndings = (value = '') => value.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

export const getWeightedLength = (value = '') => {
  const normalized = normalizeLineEndings(value);
  const lineBreaks = (normalized.match(/\n/g) || []).length;
  return normalized.length + lineBreaks;
};

export const truncateToWeightedMax = (value = '', limit: number) => {
  const normalized = normalizeLineEndings(value);
  let weighted = 0;
  let out = '';

  for (let i = 0; i < normalized.length; i += 1) {
    const ch = normalized[i];
    const nextWeight = ch === '\n' ? 2 : 1;
    if (weighted + nextWeight > limit) break;
    out += ch;
    weighted += nextWeight;
  }

  return out;
};
